import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Input, Button, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';

const CUSTOMER_USERNAME = localStorage.getItem("username");
const COMPANY_ID = localStorage.getItem("company_id");

const EditInspirationModal = ({ visible, onCancel, onSuccess, itemToEdit }) => {
    const [form] = Form.useForm();
    const [editButtonLoader, setEditButtonLoader] = useState(false);

    useEffect(() => {
        if (visible && itemToEdit) {
            // Get the identifier value from the item (check multiple possible field names)
            const identifier = itemToEdit.text || itemToEdit.identifier || itemToEdit.TEXT || itemToEdit.text_identifier || itemToEdit.identifier_text || '';
            const category = itemToEdit.category || '';
            form.setFieldsValue({ identifier, category });
        } else if (!visible) {
            form.resetFields();
        }
    }, [visible, itemToEdit, form]);

    const handleEditSave = async (values) => {
        if (!itemToEdit) return;

        setEditButtonLoader(true);
        try {
            const payload = {
                action: 'update_inspiration',
                inspiration_id: itemToEdit.id,
                identifier: values.identifier,
                category: values.category || '',
                username: CUSTOMER_USERNAME,
                company_id: COMPANY_ID
            };

            const response = await axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload);

            if (response.data && response.data.result === 'success') {
                message.success('Inspiration updated successfully');
                // Call onSuccess with updated data
                const updatedItem = {
                    ...itemToEdit,
                    identifier: values.identifier,
                    text: values.identifier,
                    category: values.category
                };
                onSuccess(updatedItem);
                onCancel();
            } else {
                message.error('Failed to update inspiration');
            }
        } catch (error) {
            console.error("Error updating inspiration:", error);
            message.error('Error updating inspiration');
        } finally {
            setEditButtonLoader(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            visible={visible}
            className="template-modal-setting small-40"
            width={788}
            maskClosable={false}
            closable={true}
            destroyOnClose={true}
            title={<span className="manrope f-14 lh-22 w-700 black-085">
                Edit</span>}
            onCancel={handleCancel}
            footer={[
                <div className="justify-in-end" key="footer">
                    <Button disabled={editButtonLoader} className="modal-okay square font-14" onClick={() => form.submit()}>
                        Save&nbsp;{editButtonLoader ? <LoadingOutlined /> : ''}
                    </Button>
                </div>
            ]}
        >
            <Row>
                <Col span={24}>
                    <Form
                        form={form}
                        onFinish={handleEditSave}
                        layout="vertical"
                    >
                        <Row type='flex'>
                            <Col span={24}>
                                <Form.Item
                                    colon={false}
                                    label={<span className="manrope f-14 black-55">Name</span>}
                                    name="identifier"
                                    rules={[
                                        { required: true, message: 'Please enter a name.' },
                                        { whitespace: true, message: 'Name cannot be blank.' }
                                    ]}
                                >
                                    <Input
                                        disabled={editButtonLoader}
                                        placeholder="Enter name"
                                        className="manrope f-14 black-55"
                                        style={{width: "100%",height:"40px"}}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type='flex'>
                            <Col span={24}>
                                <Form.Item
                                    colon={false}
                                    label={<span className="manrope f-14 black-55">Category</span>}
                                    name="category"
                                >
                                    <Input
                                        disabled={editButtonLoader}
                                        placeholder="Enter category"
                                        className="manrope f-14 black-55"
                                        style={{width: "100%",height:"40px"}}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Modal>
    );
};

export default EditInspirationModal;

